'use client';

import type { PropsWithChildren } from 'react';
import type { SelectedTimeSlotType, TimeSlotType } from '~/model/TimeSlotType';
import { createContext, useContext } from 'react';
import { useTimeslots } from '@/app/hooks/useTimeslots';

const TimeslotsContext = createContext<ReturnType<typeof useTimeslots> | undefined>(undefined);

export const useTimeslotsContext = () => {
  const context = useContext(TimeslotsContext);
  if (!context) {
    throw new Error(
      'useTimeslotsContext must be called within TimeslotsContext',
    );
  }
  return context;
};

export const TimeslotsProvider = ({
  children,
  timeslots,
  selectedTimeslots,
}: PropsWithChildren<{
  timeslots: TimeSlotType[];
  selectedTimeslots?: SelectedTimeSlotType[];
}>) => {
  const value = useTimeslots({ timeslots, selectedTimeslots });

  return (
    <TimeslotsContext.Provider value={value}>
      {children}
    </TimeslotsContext.Provider>
  );
};
